// extracted by mini-css-extract-plugin
export default {"box":"MyAddressSearch_box__RQ7XC","input":"MyAddressSearch_input__1yhmw","icon":"MyAddressSearch_icon__aEMI4"};